/**
 * Opens the sealer calculator (<topcoat-calc>, sections/topcoat-coverage-calculator.liquid) in a popup.
 * Mirrors slm-modal.js but shares nothing with it, so the Liquid Membrane calculator is never touched.
 *
 * Triggers: any element with [data-tc-modal-open] (the promo banner button).
 * Deep links: #sealer-calculator or ?calc=1 open it on page load.
 * If there is no trigger on the page the calculator is left inline, exactly as before.
 */
(function () {
  var host = null, lastFocus = null, hasTriggers = false;

  function calculator() { return document.querySelector('topcoat-calc'); }

  function open() {
    if (!host) return;
    lastFocus = document.activeElement;
    host.classList.add('is-open');
    host.removeAttribute('aria-hidden');
    document.documentElement.style.overflow = 'hidden';
    var c = host.querySelector('.tc-modal__close');
    if (c) c.focus();
  }

  function close() {
    if (!host) return;
    host.classList.remove('is-open');
    host.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (/^#sealer-calculator$/i.test(location.hash) && history.replaceState) {
      history.replaceState(null, '', location.pathname + location.search);
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function asked() {
    if (/^#(sealer-calculator|calculator)$/i.test(location.hash)) return true;
    try { var q = new URLSearchParams(location.search); return q.has('calc') || q.has('calculator'); }
    catch (e) { return false; }
  }

  function setup() {
    var calc = calculator();
    if (!calc) return;
    var triggers = document.querySelectorAll('[data-tc-modal-open]');
    hasTriggers = !!triggers.length;
    if (!hasTriggers) return;

    host = calc.closest('.shopify-section') || calc.parentElement;
    if (!host) return;
    host.classList.add('tc-modal-host');
    host.setAttribute('aria-hidden', 'true');
    host.setAttribute('role', 'dialog');
    host.setAttribute('aria-modal', 'true');

    var inner = calc.querySelector('.topcoat-calc__inner') || calc;
    if (!calc.querySelector('.tc-modal__close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tc-modal__close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', close);
      calc.insertBefore(btn, calc.firstChild);
    }

    Array.prototype.forEach.call(triggers, function (t) {
      if (t.__tcBound) return;
      t.__tcBound = true;
      t.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    host.addEventListener('click', function (e) { if (e.target === host) close(); });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && host && host.classList.contains('is-open')) close();
    });
    window.addEventListener('hashchange', function () { if (asked()) open(); });
    if (asked()) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', function () { host = null; setup(); });

  window.SealerCalculator = { open: function () { if (hasTriggers) open(); }, close: close };
})();
